import React from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import DisplayError from "../../dumb/DisplayError";
import { useState } from "react";
import TextInput from "../../dumb/TextInput";
import { setPONumber } from "../../../redux/ducks/project";

const SetPONumber = props => {
    const [show, hide, renderModal] = useModal();
    const [d_setPONumber, status, error, event] = useStatusThunk(setPONumber);
    const [name, setName] = useState();

    event.onSuccess = () => {
        hide();
        setName();
    }

    return (
        <React.Fragment>
            <button className={"button icon-button " + props.className} onClick={show}><i className="fas fa-pencil-alt"></i></button>
            {renderModal(
                <div>
                    <div className="group">
                        <div className="label">PO Number</div>
                        <TextInput set={setName} v={name} />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    {<LoadingButton loading={status == "pending"} onClick={e => d_setPONumber({projectID: props.projectID, orderNumber:name})} className="button--primary">Set PO number</LoadingButton>}
                </div>
            )}
        </React.Fragment>
    )
}

export default SetPONumber;